import React from "react";
import Nav from "../components/Nav";
import one from "../images/1.png";
import two from "../images/2.png";
import three from "../images/3.png";
import postajob from "../images/postajob.png";
import how from "../images/how.png";
import magic from "../images/magic.png";
import shortlist from "../images/shortlist.png";
import mac from "../images/mac.png";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";
import Circles from "../components/Circles";
const HowItWorks = () => {
  return (
    <div className="font-poppins">
      <Nav />
      <div className="px-5 py-20 md:px-40 relative overflow-x-clip">
        <Circles color="#0DCD9424" className="absolute left-0 top-0"></Circles>
        <Circles
          color="#148EFF2E"
          className="absolute right-0 top-1/2"
        ></Circles>
        <div>
          <p className="text-center text-3xl font-bold">How it works</p>
          <div className="mt-10 flex flex-col space-y-5">
            <div className="md:grid md:grid-cols-2 items-center">
              <div className="md:order-last">
                <img
                  src={postajob}
                  className="md:h-80 md:order-last h-52 mx-auto"
                ></img>
              </div>
              <div className="mt-6 md:mt-0">
                <div className="flex space-x-4  items-start">
                  <img src={one} className="md:h-16 h-10 md:-mt-4"></img>
                  <div>
                    <p className="text-2xl font-bold">Post a job</p>
                    <p className="mt-2">
                      Need a whiz to pen down the perfect job spec for a GPT
                      Prompt Wizard or a globe-trotting Sales Maestro? Let our
                      Recruitment Sidekick help you craft it in a snap and shoot
                      it off to your favourite job board in less time than it
                      takes to brew your morning coffee!
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="md:grid md:grid-cols-2 items-center">
              <div>
                <img src={how} className="md:h-80 h-52 mx-auto"></img>
              </div>
              <div className="mt-6 md:mt-0">
                <div className="flex space-x-4  items-start">
                  <img src={two} className="md:h-16 h-10 md:-mt-4"></img>
                  <div>
                    <p className="text-2xl font-bold">Candidate assessments</p>
                    <p className="mt-2">
                      Post your job and let Northstarz.Ai do the heavy lifting!
                      It'll conjure up candidates from the job boards, sift
                      through resumes with an eagle eye, charm them with
                      invites, and then guide them through interviews and
                      evaluations—all while you relax and await your next
                      superstar!
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="md:grid md:grid-cols-2 items-center">
              <div className="md:order-last">
                <img src={shortlist} className="md:h-80  h-52 mx-auto"></img>
              </div>
              <div className="mt-6 md:mt-0">
                <div className="flex space-x-4  items-start">
                  <img src={three} className="md:h-16 h-10 md:-mt-4"></img>
                  <div>
                    <p className="text-2xl font-bold">Connect with the best</p>
                    <p className="mt-2">
                      Once the job is published, Northstarz.Ai does all the
                      heavy lifting. It'll pull up candidates from the job
                      boards, sift through resumes with an eagle eye, charm them
                      with invites, and then guide them through interviews and
                      evaluations. Fancy a little control? Flex your override
                      power, cherry-pick the cream of the crop, and roll out the
                      red carpet for the face-to-face showdown.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="my-10 md:py-20 px-5 md:px-40">
        <div className="md:grid grid-cols-2 gap-4 items-center">
          <img src={magic} className="md:order-last"></img>
          <div>
            <p className="font-bold md:text-2xl text-xl ">
              The magic of AI explained
            </p>
            <p className="mt-5">
              Northstarz.Ai is your AI-powered recruitment ally, offering a
              comprehensive evaluation of candidates from resume screening to
              interview performance. With an eye for detail akin to a seasoned
              recruiter, our AI examines resumes, highlighting experience,
              skills, and achievements against job criteria for a cumulative
              score. Candidates then proceed to AI-conducted virtual interviews,
              assessed on communication, critical thinking, adaptability,
              leadership, and comprehension, culminating in a definitive
              interview score. Voice Confidence analysis further refines
              candidate ranking, all seamlessly displayed on your dashboard,
              ensuring you proceed with only the top-tier candidates.
            </p>
          </div>
        </div>
      </div>
      <div className="my-10 md:py-20 px-5 md:px-40">
        <div className="bg-[#148EFFE5] rounded-xl px-10 py-10">
          <div className="md:grid grid-cols-2 gap-5 items-center">
            <img src={mac}></img>
            <div className="text-white">
              <p className="text-2xl font-bold">
                The 1st AI recruitment co-pilot you will ever hire!
              </p>
              <p className="text-xl my-2">Hire faster, deliver efficiency!</p>
              <Link to="/request">
                <button className="bg-white px-5 py-2 rounded-xl mt-5 text-[#148EFFE5]">
                  Schedule a call
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <Footer></Footer>
    </div>
  );
};

export default HowItWorks;
